import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ReactiveFormsAbstractionsModule } from '@innogy/feh/rfa';

import {
  fehSolarPanelsStoreSelectorKey,
  reducers,
} from './feh-solar-panels.state';
import { SolarPanelsFunnelEffects } from './solar-panels-funnel/solar-panels-funnel.effects';
import { SolarPanelsWizardEffects } from './solar-panels-wizard/solar-panels-wizard.effects';
import { SolarPanelsOrderFormEffects } from './solar-panels-order-form/solar-panels-order-form.effects';
import { SolarPanelsResultOverviewEffects } from './solar-panels-result-overview/solar-panels-result-overview.effects';
import { SolarPanelsProductOverviewEffects } from './solar-panels-products/solar-panels-product-overview.effects';
import { SolarPanelsSuitabilityCheckEffects } from './solar-panels-suitability-check/solar-panels-suitability-check.effects';

@NgModule({
  imports: [
    ReactiveFormsAbstractionsModule,
    StoreModule.forFeature(fehSolarPanelsStoreSelectorKey, reducers),
    EffectsModule.forFeature([
      SolarPanelsFunnelEffects,
      SolarPanelsWizardEffects,
      SolarPanelsOrderFormEffects,
      SolarPanelsResultOverviewEffects,
      SolarPanelsProductOverviewEffects,
      SolarPanelsSuitabilityCheckEffects,
    ]),
  ],
})
export class FehSolarPanelsStoreModule {}
